// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"2579": "admin-app","2580": "bc-driver-tour","2581": "driver-tour","2582": "howler-sounds","2584": "kalman-filter","2585": "lib-axios","2587": "lib-router","2588": "logrocket","2589": "lucide-icons","2592": "platform-app-shortcut","2593": "polyfills-core-js","2594": "polyfills-dom","2595": "posthog","2596": "process.worker","2597": "sentry",}[chunkId] || chunkId) + ".js"
}